import { getDriverAccessToAttorneySupport, getDriverAnnualPrice, getDriverPrice } from '@nerdwallet/marketplace/drivers/estate-planning';
export var getQuickFactAccessToAttorneySupport = function getQuickFactAccessToAttorneySupport(offer) {
  return getDriverAccessToAttorneySupport(offer);
};
export var getQuickFactAnnualPrice = function getQuickFactAnnualPrice(offer) {
  return getDriverAnnualPrice(offer);
};
export var getQuickFactPrice = function getQuickFactPrice(offer) {
  return getDriverPrice(offer);
};